<template>
  <div class="auth">


    <h1>{{pageTitle}}</h1>

    <div class="auth-block">

      <h2>Вход в систему</h2>

      <div class="auth-field">
        <label for="email">Электронная почта</label>
        <input type="text" id="email" v-model="email">
      </div>

      <div class="auth-field">
        <label for="password">Пароль</label>
        <input type="password" id="password" v-model="password" v-on:keyup.enter.prevent="logMe">
      </div>


      <div class="auth-field">
        <label for="actButton"></label>
        <a href="#" class="button action-button" id="actButton" v-on:click.prevent="logMe">Войти</a>
      </div>

    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import inputMaterial from './html/InputMaterial';

export default {
  name: 'auth',
  data() {
    return {
      pageTitle: 'Planogram',
      msg: 'Необходима авторизация',
      email: '',
      password: '',
      bodyClassName: 'body',
    };
  },

  methods: {
    logMe() {
      this.$auth.login({
        data: {
          email: this.email,
          password: this.password,
        },
        success(data) {
          this.$store.dispatch('auth', data.data.user).then(() => {
            this.$router.push('/pharmacies/');
          });
        },
        error() {

        },
        rememberMe: true,
        fetchUser: false,
      });
    },
  },
  mounted() {
    document.body.classList.add(this.bodyClassName);
    document.getElementById('header').classList.add('hide');
  },
  destroyed() {
    document.body.classList.remove(this.bodyClassName);
    document.getElementById('header').classList.remove('hide');
  },

  components: { inputMaterial },
};
</script>



<style lang="less" scoped>
  h1{
    /* Planogram: */
    opacity: 0.9;
    font-family: 'Roboto', sans-serif;
    font-size: 80px;
    color: #45DE91;
    text-align: center;
  }

  h2{
    text-align: center;
    font-size: 35px;
    color: #262626;
  }

  .auth-block{
    width: 600px;
    height: 400px;
    background: #ffffff;
    margin: 0 auto;
    padding-top: 40px;
  }

  .auth-field{
    width:416px;
    margin: 0 auto 24px;
    font-size: 0;
  }

  label{
    width: 153px;
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
  }

  input{
    display: inline-block;
    vertical-align: middle;
    width: 260px;
    box-sizing: border-box;
    outline: none;
    box-shadow: none;
    font-family: 'Roboto', sans-serif;
    border:1px solid #ccc;
    border-radius: 3px;
    padding: 0 10px 0 10px;
    -webkit-box-shadow: none;
    font-size: 18px;
    line-height: 37px;
  }

  .action-button{
    width: 260px;
    height: 40px;
  }


</style>


// WEBPACK FOOTER //
// Auth.vue?3170e09a